import { render, staticRenderFns } from "./individualProvee.vue?vue&type=template&id=bfd2f4b6"
import script from "./individualProvee.vue?vue&type=script&lang=js"
export * from "./individualProvee.vue?vue&type=script&lang=js"
import style0 from "./individualProvee.vue?vue&type=style&index=0&id=bfd2f4b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports